import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Outlet } from 'react-router-dom';
import { NavDrawer } from '@Components/NavDrawer';
import { Box } from '@mui/material';
const BLUE_GRAY_50 = '#ECEFF1';
const Layout = ({ logoColor }) => {
    const navWidth = 218 + 20;
    return (_jsxs(Box, { sx: { display: 'flex', width: "inherit", height: "100%", backgroundColor: BLUE_GRAY_50 }, children: [_jsx(NavDrawer, { logoColor: logoColor, maxWidth: navWidth }), _jsx(Box, { sx: { marginLeft: `${navWidth}px`, padding: '24px', width: "100%", height: 'inherit' }, children: _jsx(Outlet, {}) })] }));
};
export default Layout;
